angular.module('app.controllers').controller('FavoritesListCtrl', ['$scope', '$rootScope', 'APIFavorites'].append(function(self, root, APIFavorites) {
  var ref, shortcode, slugs;
  shortcode = ((ref = root.user) != null ? ref.shortcode : void 0) || root.tuser || 'test';
  self.day = 1;
  self.setDay = function(day) {
    return self.day = day;
  };
  self.days = [
    {
      title: '20.05',
      title_sm: '.25',
      day: 1
    }
  ];
  self.loadData = function(entrycode, slug) {
    return APIFavorites.query({
      entrycode: entrycode,
      fullentry: true,
      shortcode: shortcode,
      tuser: root.tuser || null,
      lang: root.lang || 'es'
    }, function(data) {
      self[slug] = data;
      if (entrycode === 'sl' && self.slots.length) {
        if (self.slots.filter(function(slot) {
          return slot.day_int === 1;
        }).length) {
          return;
        }
        if (!self.slots.filter(function(slot) {
          return slot.day_int === 1;
        }).length) {
          return self.day = 2;
        }
        if (!self.slots.filter(function(slot) {
          return slot.day_int === 2;
        }).length) {
          return self.day = 3;
        }
      }
    }, function(response) {
      return UI.notify(false, response.error.data);
    });
  };
  self.loadData('ex', 'exhibitors');
  self.loadData('vi', 'videos');
  self.loadData('sl', 'slots');
  self.loadData('us', 'users');
  self.loadData('do', 'downloads');
  self.loadData('li', 'links');
  slugs = {
    'ex': 'exhibitors',
    'vi': 'videos',
    'sl': 'slots',
    'us': 'users',
    'do': 'downloads',
    'li': 'links'
  };
  root.$on('forceFavs', function(event, entrycode, slug = null, fav_code) {
    var fav_index;
    if (!self.at('favs')) {
      return;
    }
    if (slug == null) {
      slug = slugs[entrycode];
    }
    fav_index = self[slug].findIndex(function(item) {
      return item.fav_code === fav_code;
    });
    self[slug].splice(fav_index, 1);
    if (entrycode === 'sl' && self.slots.length) {
      if (!self.slots.filter(function(slot) {
        return slot.day_int === self.day;
      }).length) {
        return self.day = self.slots[0].day_int;
      }
    }
  });
  return self.openProgramModal = function(data = null, id = null) {
    return root.$broadcast('onProgramModalOpen', data, id);
  };
}));
